<template>
    <AllConsolidatedContainer
        :group="selectedGroup"
        :project="selectedProject"
        :month="selectedMonth"
        :estimated="estimated"
        :qtypeParam="qtypeParam"
    ></AllConsolidatedContainer>
</template>

<script>
import store from '@/store'
import AllConsolidatedStore from '@/modules/AllConsolidated/_store'
import AllConsolidatedContainer from '@/modules/AllConsolidated'
import useSelectProjectAndGroup from '@/composables/useSelectProjectAndGroup'
import useSelectMonth from '@/composables/useSelectMonth'
import { getCurrentInstance } from '@vue/composition-api'

const STORE_KEY = '$_allConsolidated'
export default {
    components: {
        AllConsolidatedContainer
    },
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const store = vm.$store
        const {
            selectedGroup,
            selectedProject,
            estimated,
            qtypeParam,
            setInitialAccountSelect
        } = useSelectProjectAndGroup()
        const {
            selectedMonth
        } = useSelectMonth()
        if (!selectedProject.value?.projectIdx && !selectedGroup.value?.groupIdx) {
            setInitialAccountSelect(true)
        }
        store.dispatch(`${STORE_KEY}/fetchAllConsolidated`, {
            ...qtypeParam.value,
            month: selectedMonth.value,
            estimated: estimated.value
        })

        return {
            selectedGroup,
            selectedProject,
            selectedMonth,
            estimated,
            qtypeParam
        }
    },
    beforeRouteEnter (to, from, next) {
        if (!(STORE_KEY in store._modules.root._children)) {
            store.registerModule(STORE_KEY, AllConsolidatedStore)
        }
        next()
    }
}
</script>

<style>

</style>
